<template>
  <v-app-bar v-if="partnerGroupDetails.ViewType !== 'Luxury' || this.$route.name !== 'Homepage'" light elevation="1" height="60" app class="align-center">
<!--    <v-app-bar-nav-icon v-if="isMobile" @click.stop="toggleNavigationDrawer" />-->

    <!-- header for booking screen -->
<!--    <v-row class="ma-0" :class="hideHeaderAndFooter ? '' : 'd-none'">-->
<!--      <v-img-->
<!--        :src="partnerGroupDetails.Logo"-->
<!--        class="ma-0"-->
<!--        alt="theDrivingForce"-->
<!--        style="cursor: pointer"-->
<!--        contain-->
<!--        position="center center"-->
<!--        height="45"-->
<!--        width="45"-->
<!--        @click="goHome"-->
<!--      />-->
<!--    </v-row>-->

    <v-row
      justify="center"
      align="center"
      :class="hideHeaderAndFooter ? 'd-none' : ''"
      class="flex-nowrap ma-0"
    >
      <v-img
        :src="partnerGroupDetails.Logo"
        ref="LogoImage" @load="getSizes"
        class="ma-0 mr-1"
        alt="theDrivingForce"
        style="cursor: pointer"
        contain
        position="left center"
        :height="logoImageHeight"
        :max-width="logoImageWidth"
        @click="goHome"
      />

      <v-btn
        class="mx-2 px-1 grey--text text--darken-1 text-body-1"
        text
        @click.stop="toggleNavigationDrawer"
      >
        <v-icon size="30" color="primary">menu</v-icon>
      </v-btn>

      <Search />

      <v-spacer class="hidden-md-and-down" />

      <template v-if="!isMobile">
        <!-- Themes for big screen -->
        <HeaderThemes />
        <!-- <div
          class="primary--text text-wrap text-body-1 cursor--pointer mr-4"
          @click="onAboutUsClick"
        >
          {{ $translate('ABOUTUS') }}
        </div> -->
      </template>

      <v-divider vertical light inset class="hidden-sm-and-down" />

      <!-- translation menu on md and up -->
      <HeaderTranslations v-if="!isMobile" :isMobile="isMobile" />

      <!-- User profile -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="onAccountBtnClick" v-bind="attrs" v-on="on">
            <v-icon color="primary">person</v-icon>
          </v-btn>
        </template>
        <span>{{ $translate('ACCOUNT_TITLE') }}</span>
      </v-tooltip>

      <shopping-cart />

      <div v-if="userLoggedIn">
        <shopping-list />
      </div>
    </v-row>

    <v-dialog v-model="alertBeforeLogout" width="500" persistent>
      <v-card>
        <v-alert icon="ti-alert" type="warning">
          {{ $translate('SHOPPINGCART_NOT_EMPTY') }}
        </v-alert>
        <v-card-text>
          {{ $translate('SHOPPINGCART_NOT_EMPTY_DESCRIPTION') }}
        </v-card-text>
        <v-divider />
        <!--the list with all the shoppingCart items-->
        <ShoppingCartList />
        <v-divider />
        <v-card-text class="font-weight-black mt-4">
          {{ $translate('SHOPPINGCART_SURE_ABOUT_LOGGING_OUT') }}
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            text
            depressed
            @click="alertBeforeLogout = false"
          >
            {{ $translate('CANCEL') }}
          </v-btn>
          <v-btn color="primary" depressed @click="acceptLogout">
            {{ $translate('USER_WANT_LOGOUT') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>

<script>
import uiHelpers from '@/shared/ui_helpers';
import UserJS from '@/objects/UserObject';
import HeaderThemes from '@/components/generalComponents/header/HeaderThemes';
import ShoppingCart from './ShoppingCart.vue';
import ShoppingCartList from './ShoppingCartList.vue';
import Search from './Search.vue';
import ShoppingList from './ShoppingList.vue';
import HeaderTranslations from './HeaderTranslations.vue';

export default {
  name: 'Header',
  components: {
    ShoppingCart,
    Search,
    ShoppingCartList,
    ShoppingList,
    HeaderTranslations,
    HeaderThemes,
  },
  mixins: [uiHelpers],
  computed: {
    partnerGroupDetails() {
      const details = this.$store.getters['Account/partnerGroupDetails'];
      if (details == null) {
        return {};
      }
      return details;
    },
    hideHeaderAndFooter() {
      return this.$store.getters.getHideHeaderAndFooter;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    userLoggedIn() {
      return this.$store.getters['auth/isValid'];
    },
  },
  created() {
    window.EventBus.listen('showLogoutAlert', this.showLogoutAlert);
  },
  beforeDestroy() {
    window.EventBus.removeListener('showLogoutAlert', this.showLogoutAlert);
  },
  data() {
    return {
      alertBeforeLogout: false,
      logoImageHeight: 40,
      logoImageWidth: 40,
    };
  },
  methods: {
    acceptLogout() {
      this.alertBeforeLogout = false;
      this.logOut();
    },
    showLogoutAlert() {
      this.alertBeforeLogout = true;
    },
    getSizes(){
      // unless loading error
      const {naturalHeight, naturalWidth} = this.$refs.LogoImage.image;
      if (naturalHeight > 0) {
        this.logoImageWidth = (naturalWidth * this.logoImageHeight) / naturalHeight;
        console.log(`LOGO IMAGE height: ${this.logoImageHeight}, width: ${this.logoImageWidth}`);
      }
    },
    goHome() {
      setTimeout(() => {
        this.$router.push({
          name: 'Homepage',
          params: {
            account_id: this.$store.getters.getRegion,
          },
        });
      }, 10);
    },
    toggleNavigationDrawer() {
      this.$emit('toggle-drawer');
    },
    onAccountBtnClick() {
      if (this.userLoggedIn) {
        // User logged in, navigate to account page
        this.$router.push({
          name: 'UserSettings',
          params: { myOrders: true },
        });
      } else {
        // User is not logged in
        window.EventBus.fire('triggerOpenAccountFromMenu', {
          toggle: true,
          component: 'Login',
        });
      }
    },
    logOut() {
      UserJS.logout();
      window.EventBus.fire(
        'activateSnackBar',
        this.$translate('SUCCESS_LOGGED_OUT')
      );

      this.$router.push({
        name: 'Homepage',
        params: {
          account_id: this.$store.getters.getRegion,
        },
      });
    },
    // onAboutUsClick() {
    //   this.$router.push({ name: 'AboutUs' });
    // },
  },
};
</script>
<style scoped>
.v-responsive {
  flex-grow: 0;
  flex-shrink: 0;
}
</style>
